var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var bindActionCreators = require("redux").bindActionCreators;
var Modal = require('./modal.jsx');
var modalActions = require('../../../modules/modals/actions/modal');

var PromiseModal = createReactClass({

  onClose: function() {
    this.props.hideModal();
    this.props.modal.props.close && this.props.modal.props.close();
  },

  render: function() {
    var id = this.props.modal.props.id || 'promis';

    return (
      <Modal onClose={this.onClose} id={id}>
        <div className="reveal-bd">
          <p><strong>We love your enthusiasm, but currently you can only track your symptoms once per day.</strong></p>
          <p>Please try again tomorrow.</p>
        </div>
        <div className="reveal-ft">
          <a className="button expanded" onClick={this.onClose}>Got it</a>
        </div>
      </Modal>
    );
  }

});

var mapDispatchToProps = function(dispatch) {
  return bindActionCreators(modalActions, dispatch);
}

module.exports = ReactRedux.connect(null, mapDispatchToProps)(PromiseModal);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/promisModal.jsx